import { Calendar, MapPin, Ticket } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateAndTimeIntervalOnTimeZone } from 'utils/events';
import { EventData } from './types';

interface EventDetailsOrderConfirmationPageProps {
  event: EventData;
  numberOfTickets: number;
}

const EventDetailsOnOrderConfirmationPage: React.FC<
  EventDetailsOrderConfirmationPageProps
> = ({
  event: {
    name,
    timeInterval: { startsAt, endsAt },
    dateTimeFormat: { timeFormat, timezone, dateFormat },
    location,
  },
  numberOfTickets,
}) => {
  const { t } = useTranslation();
  const eventFormattedDate =
    !startsAt && !endsAt
      ? t('event.perpetual')
      : formatDateAndTimeIntervalOnTimeZone(
          timezone,
          dateFormat,
          timeFormat,
          startsAt,
          endsAt,
          t('common.at'),
        );

  return (
    <div>
      <h2 className="title-md">{name}</h2>
      <div className="mt-[16px]">
        <div className="flex flex-col md:flex-row">
          <div className="flex items-center text-neutral-800 w-[120px]">
            <Calendar size={16} />
            <p className="p1-medium ml-[8px]">
              {t('orderConfirmationPage.dateAndTime')}
            </p>
          </div>
          <p className="ml-[24px] p1-medium flex items-center">
            {eventFormattedDate}
          </p>
        </div>
        <div className="flex flex-col md:flex-row mt-[6px]">
          <div className="flex items-center text-neutral-800 w-[120px]">
            <MapPin size={16} />
            <p className="p1-medium ml-[8px]">
              {t('orderConfirmationPage.location')}
            </p>
          </div>
          <p className="ml-[24px] p1-medium flex items-center">{location}</p>
        </div>
        <div className="flex flex-col md:flex-row mt-[6px]">
          <div className="flex items-center text-neutral-800 w-[120px]">
            <Ticket size={16} />
            <p className="p1-medium ml-[8px]">
              {t('orderConfirmationPage.numberOfTickets')}
            </p>
          </div>
          <p className="ml-[24px] p1-medium flex items-center">
            {numberOfTickets}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsOnOrderConfirmationPage;
